import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { akcizeApi } from '../../api/services';
import { useAlerts } from '../../custom/Alerts';
import { mesecNaziv } from './format';

/** gorivo izdato vozilu u mesecu: litri (obavezno), prijavljeni km i dokument (izdatnica, otpremnica, kartica) */
export default function IzdavanjeDialog({ companyId, red, mesec, celija, onHide, onSacuvano }) {
    const alerts = useAlerts();
    const [litara, setLitara] = useState(celija.litara);
    const [kmPr, setKmPr] = useState(celija.kmPrijavljeno);
    const [dokument, setDokument] = useState(celija.dokument || '');
    const [radi, setRadi] = useState(false);
    const [g, m] = mesec.split('-').map(Number);

    const sacuvaj = async () => {
        if (litara == null) { alerts.warn('Unesite količinu goriva.', 'Gorivo'); return; }
        setRadi(true);
        try {
            await akcizeApi.sacuvajIzdavanje({ id: celija.izdavanjeId || undefined, companyId, vehicleId: red.vehicleId, godina: g, mesec: m, litara, kmPrijavljeno: kmPr, dokument: dokument || null });
            alerts.success('Sačuvano.');
            onSacuvano();
        } catch { /* toast */ }
        setRadi(false);
    };
    const obrisi = async () => {
        if (!(await alerts.confirm('Brisanje', `Obrisati gorivo za ${red.reg}, ${mesecNaziv(mesec)}?`))) return;
        setRadi(true);
        try { await akcizeApi.obrisiIzdavanje(celija.izdavanjeId); onSacuvano(); } catch { /* toast */ }
        setRadi(false);
    };

    return (
        <Dialog header={`Gorivo — ${red.reg}, ${mesecNaziv(mesec)}`} visible onHide={onHide} style={{ width: 'min(30rem, 94vw)' }} modal draggable={false}
            footer={(
                <div className="dialog-footer">
                    {celija.izdavanjeId && <Button label="Obriši" icon="pi pi-trash" severity="danger" text onClick={obrisi} disabled={radi} />}
                    <Button label="Otkaži" text severity="secondary" onClick={onHide} />
                    <Button label="Sačuvaj" icon="pi pi-check" onClick={sacuvaj} loading={radi} />
                </div>
            )}>
            <div className="form-grid">
                <div className="field">
                    <label htmlFor="akc-lit">Izdato goriva (L) <span className="req">*</span></label>
                    <InputNumber inputId="akc-lit" value={litara} onValueChange={(e) => setLitara(e.value)} minFractionDigits={0} maxFractionDigits={2} min={0} locale="sr-RS" />
                </div>
                <div className="field">
                    <label htmlFor="akc-km">Prijavljeno km (tabela firme)</label>
                    <InputNumber inputId="akc-km" value={kmPr} onValueChange={(e) => setKmPr(e.value)} min={0} locale="sr-RS" useGrouping />
                </div>
                <div className="field" style={{ gridColumn: '1 / -1' }}>
                    <label htmlFor="akc-dok">Dokument</label>
                    <InputText id="akc-dok" value={dokument} maxLength={120} onChange={(e) => setDokument(e.target.value)} placeholder="Izdatnica, otpremnica, izvod kartice…" />
                </div>
            </div>
            <p className="muted" style={{ margin: '.5rem 0 0' }}>
                Km iz tahografa za ovaj mesec: <b>{celija.kmTahograf == null ? 'nema očitavanja' : `${celija.kmTahograf}${celija.delimicno ? ' (deo meseca)' : ''}`}</b>
            </p>
        </Dialog>
    );
}
